import Swiper from 'swiper';
import {
    Autoplay,
    EffectFade,
    Mousewheel,
    Navigation,
    Pagination,
} from 'swiper/modules';

Swiper.use([
    Autoplay,
    EffectFade,
    Navigation,
    Mousewheel,
    Pagination,
]);

const getSliders = () => document.querySelectorAll('.js-slider');

const init = () => {
    const sliders = getSliders();
    if (sliders.length > 0) {
        sliders.forEach((slider) => {
            let offset;
            if (slider.dataset.offset !== undefined) {
                offset = Number(slider.dataset.offset);
            } else {
                offset = 48;
            }

            const opts = {
                slidesPerView: 'auto',
                spaceBetween: slider.dataset.gutter !== undefined
                    ? Number(slider.dataset.gutter)
                    : 0,
                grabCursor: true,
                mousewheel: {
                    forceToAxis: true,
                },
                navigation: {
                    nextEl: slider.querySelector('.swiper-button-next'),
                    prevEl: slider.querySelector('.swiper-button-prev'),
                },
                pagination: {
                    el: slider.querySelector('.swiper-pagination'),
                    clickable: true,
                    bulletActiveClass: '!opacity-80',
                    renderBullet: (index, className) => `<button class="${className} size-2.5 border-2 border-orange bg-black rounded-full opacity-40 pointer-events-auto"></button>`,
                },
                slidesOffsetAfter: offset,
            };

            if (undefined !== slider.dataset.loop) {
                opts.loop = true;
            }

            if (undefined !== slider.dataset.fade) {
                opts.effect = 'fade';
            }

            if (undefined !== slider.dataset.centeredSlides) {
                opts.centeredSlides = true;
            }

            if (undefined !== slider.dataset.autoplay
                && slider.dataset.autoplay !== '0') {
                opts.autoplay = {
                    delay: Number(slider.dataset.autoplay) * 1000,
                };
            }

            const swiper = new Swiper(slider, opts); // eslint-disable-line no-unused-vars
        });
    }
};

export default init;
